import { render } from "./presenca-turmas_config.vue?vue&type=template&id=4e4b662c&scoped=true"
import script from "./presenca-turmas_config.vue?vue&type=script&lang=js"
export * from "./presenca-turmas_config.vue?vue&type=script&lang=js"

import "./presenca-turmas_config.vue?vue&type=style&index=0&id=4e4b662c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e4b662c"]])

export default __exports__